import { createStyles } from '@material-ui/core/styles';

export default createStyles({
  datagrid: {
    margin: '15px 0px'
  }
});
